// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CashflowFromJSON(json) {
    return {
        'year': json['year'],
        'quarter': json['quarter'],
        'contribution': !exists(json, 'contribution') ? undefined : json['contribution'],
        'distribution': !exists(json, 'distribution') ? undefined : json['distribution'],
        'netCash': !exists(json, 'netCash') ? undefined : json['netCash'],
        'navPreview': !exists(json, 'navPreview') ? undefined : json['navPreview'],
        'tvpi': !exists(json, 'tvpi') ? undefined : json['tvpi'],
    };
}
export function CashflowToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'year': value.year,
        'quarter': value.quarter,
        'contribution': value.contribution,
        'distribution': value.distribution,
        'netCash': value.netCash,
        'navPreview': value.navPreview,
        'tvpi': value.tvpi,
    };
}
